<template>
    <b-form @submit.stop.prevent="saveDocument" novalidate="novalidate" autocomplete="off">
        <div class="row">
            <div class="col-8">
                <div class="form-group bmd-form-group is-filled">
                    <label for="client" class="bmd-label-floating">Cliente:</label>
                    <input refs="client" type="text" class="form-control" v-model="contract.client.name" disabled="" />
                </div>
            </div>
            <div class="col-4">
                <div class="form-group bmd-form-group is-filled">
                    <label for="contract" class="bmd-label-floating">Contrato:</label>
                    <input refs="contract" type="text" class="form-control" v-model="contract.physical_proposal" disabled="" />
                </div>
            </div>
        </div>
        <hr />
        <div v-for="(iterator, index) in files"
            class="row">
            <div class="col-2">
                <label>
                    {{ iterator.title }}<br />
                    <small v-if="iterator.refer != null">
                        <a :href="iterator.refer" target="_blank">Baixar {{ iterator.title }}</a>
                    </small>
                </label>
            </div>
            <div class="col-3" v-show="!(isSalesman() && !is_with_the_salesman)">
                <input 
                    type="file"
                    :id="'file_input_' + index"
                    @input="handleFileInput(index, $event.target.files[0])" />
            </div>
            <div class="col-7">
                <div class="form-group bmd-form-group has-danger">
                    <label class="error">{{ iterator.validation }}</label>
                </div>
            </div>
        </div>
        <b-button v-on:click="downloadAll" type="button" variant="info" v-if="!isSalesman()">Baixar todos documentos</b-button>
        <b-button :disabled="loading || (isSalesman && !is_with_the_salesman)" type="submit" variant="primary">Salvar</b-button>
        <b-button v-on:click="sairModal" type="button" variant="secundary">Sair</b-button>
    </b-form>
</template>

<script>
export default {
    computed: {
        contract: {
            set(contract) {},
            get() {
                if (this.$store.state.contracts.item.contract_documents != undefined && this.$store.state.contracts.item.contract_documents.length > 0) {
                    const documents = this.$store.state.contracts.item.contract_documents;
                    const files = this.files;
                    documents.forEach(document => {
                        const keyDocument = document.description;
                        const referDocument = document.file;
                        
                        files.forEach(file => {
                            const keyFile = file.key;
                            if (keyFile == keyDocument) {
                                this.downloadAndConvertToBase64(referDocument)
                                    .then(base64Data => {
                                        file.file = base64Data;
                                        file.mimetype = "application/pdf";
                                        file.size = 200;
                                    });
                                file.refer = referDocument
                            }
                        });
                    })
                }

                return this.$store.state.contracts.item;
            }
        },
        is_with_the_salesman() {
            if (this.$store.state.contracts.item == undefined) {
                return false
            }

            return this.$store.state.contracts.item.is_with_the_salesman
        }
    },
    data() {
        return {
            files: [
                {
                    "file": null,
                    "size": 0,
                    "mimetype": null,
                    "required": true,
                    "title": "Contrato Digital",
                    "key": "contrato-digital.pdf",
                    "validation": null,
                    "refer": null,
                    "updated": false
                },
                {
                    "file": null,
                    "size": 0,
                    "mimetype": null,
                    "required": true,
                    "title": "Vias Contrato Assinadas",
                    "key": "via-contrato-assinadas.pdf",
                    "validation": null,
                    "refer": null,
                    "updated": false
                },
                {
                    "file": null,
                    "size": 0,
                    "mimetype": null,
                    "required": true,
                    "title": "Documento Identificação",
                    "key": "document-identificacao.pdf",
                    "validation": null,
                    "refer": null,
                    "updated": false
                },
                {
                    "file": null,
                    "size": 0,
                    "mimetype": null,
                    "required": true,
                    "title": "Comprovante de Endereço",
                    "key": "comprovante-de-endereco.pdf",
                    "validation": null,
                    "refer": null,
                    "updated": false
                },
                {
                    "file": null,
                    "size": 0,
                    "mimetype": null,
                    "required": this.$store.state.contracts.item.client == undefined ? false : (this.$store.state.contracts.item.client.cpf_cnpj.length > 11 ? true : false),
                    "title": "Contrato Social",
                    "key": "contrato-social.pdf",
                    "validation": null,
                    "refer": null,
                    "updated": false
                },
                {
                    "file": null,
                    "size": 0,
                    "mimetype": null,
                    "required": this.$store.state.contracts.item.client == undefined ? false : (this.$store.state.contracts.item.client.cpf_cnpj.length > 11 ? true : false),
                    "title": "Cartão CNPJ",
                    "key": "cartao-cnpj.pdf",
                    "validation": null,
                    "refer": null,
                    "updated": false
                }
            ],
            formValidations: {
                files: {
                    required: true,
                    size: 15728640,
                    mimes: ["application/pdf"]
                }
            },
            loading: false
        };
    },
    created() {
        this.getContract();
    },
    methods: {
        sairModal() {
            this.$root.$emit("updateList");
            this.$root.$emit("hideModal");
        },
        isSalesman() {
            return this.$store.state.auth.user.profile.type_profile_id == 4;
        },
        downloadAndConvertToBase64(url) {
            return new Promise((resolve, reject) => {
                // Baixar o PDF da URL usando fetch
                fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Erro ao baixar o arquivo');
                    }
                    return response.blob();
                })
                .then(blob => {
                    // Ler o conteúdo do PDF como ArrayBuffer
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);

                    // Converte o conteúdo do PDF para base64 quando a leitura estiver completa
                    reader.onloadend = () => {
                    const base64data = reader.result;
                    // Obtém apenas os dados após a vírgula (base64)
                    const base64 = base64data.split(',')[1];
                    resolve(base64);
                    };

                    reader.onerror = () => {
                    reader.abort();
                    reject(new DOMException('Erro ao ler o arquivo.'));
                    };
                })
                .catch(error => {
                    console.error('Ocorreu um erro:', error);
                    reject(error);
                });
            });
        },
        async downloadAll() {
            var self = this;

            self.$root.$emit("onLoading");

            const response = self.$store.dispatch(
                "contracts/downloadFull",
                this.$route.params.id
            )

            response.then(function(_downloadZip) {
                let filename = 'contrato_' + self.$store.state.contracts.item.physical_proposal + '.zip'
                let blob = new Blob([_downloadZip], {type: 'application/zip'});

                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = filename 
                link.click();

                self.$root.$emit("onLoading")
            });

            response.catch(function() {
                self.$root.$emit("onLoading");
            });
        },
        getContract() {
            this.$root.$emit("onLoading");

            this.$store.dispatch(
                "contracts/get",
                this.$route.params.id
            )
                .then(resp => {
                    this.$root.$emit("onLoading");
                })
                .catch(err => {
                    this.$root.$emit("onLoading");  
                })
        },
        async handleFileInput(index, file) {
            if (file) {
                this.$set(this.files[index], 'size', file.size);
                this.$set(this.files[index], 'mimetype', file.type);
                this.$set(this.files[index], 'file', await this.getBase64(file));
                this.$set(this.files[index], 'updated', true);
            }
        },
        async saveDocument() {
            var self = this;
            var valid = true;
            var files = self.files;
            var newFiles = [];

            files.forEach(iterator => {
                var file = iterator.file;
                var required = iterator.required;
                var title = iterator.title;
                var key = iterator.key;
                iterator.validation = null;

                if (required && file == null) {
                    iterator.validation = title + " é obrigatório!";
                    valid = false;
                }

                if (file != null && !self.formValidations.files.mimes.includes(iterator.mimetype)) {
                    iterator.validation = "O formato do arquivo é inválido, só são aceitos arquivos em pdf";
                    valid = false;
                } else if (file != null && iterator.size > self.formValidations.files.size) {
                    iterator.validation = "O tamanho máx do arquivo é de " + (self.formValidations.files.size / (1024*1024)).toFixed(2) + " mb";
                    valid = false;
                }

                if (file != null) {
                    newFiles.push({
                        name: key,
                        content: file,
                        updated: iterator.updated
                    })
                }
            });

            if (valid && newFiles.length > 0){
                self.loading = true;
                self.$root.$emit('onLoading');

                const response = await this.$store.dispatch(
                    "contracts/sendDocument",
                    {
                        id: this.$route.params.id,
                        files: newFiles
                    }
                );
            
                this.loading = false;
                this.$root.$emit("updateList");
                this.$root.$emit("hideModal");
                this.$notify.success('Documentos enviados com sucesso');
                this.$root.$emit("onLoading");
            }

        },
    }
};
</script>